var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRespectGray100(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 50 100 C 77.613281 100 100 77.613281 100 50 C 100 22.386719 77.613281 0 50 0 C 22.386719 0 0 22.386719 0 50 C 0 77.613281 22.386719 100 50 100 Z M 50 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.058824%,39.607843%,36.862745%)",
      fillOpacity: 1
    },
    d: "M 50.003906 41.5 C 58.808594 31.996094 74.789062 38.066406 75 51.28125 C 75.1875 62.9375 58.40625 71.242188 50.488281 78.289062 C 50.214844 78.542969 49.792969 78.535156 49.515625 78.289062 C 41.765625 71.394531 25 62.386719 25 51.296875 C 25 38.101562 41.203125 32.003906 50.003906 41.5 Z M 49.511719 43.144531 C 41.183594 33.753906 26.46875 39.21875 26.46875 51.296875 C 26.46875 54.550781 28.207031 57.730469 30.796875 60.753906 L 44.9375 46.632812 C 45.21875 46.351562 45.683594 46.324219 45.972656 46.613281 L 50.304688 50.769531 C 52.773438 53.136719 56.226562 49.328125 53.898438 47.1875 Z M 51.023438 42.546875 L 54.890625 46.113281 C 58.660156 49.578125 53.167969 55.550781 49.292969 51.824219 L 45.480469 48.160156 L 31.773438 61.84375 C 32.984375 63.144531 34.332031 64.414062 35.753906 65.644531 L 47.835938 53.089844 C 48.503906 52.394531 49.558594 53.40625 48.890625 54.101562 L 36.871094 66.59375 C 38.230469 67.726562 39.636719 68.824219 41.027344 69.875 L 52.976562 57.675781 C 53.652344 56.984375 54.695312 58.011719 54.027344 58.695312 L 42.203125 70.769531 C 43.503906 71.75 44.820312 72.71875 46.121094 73.703125 L 57.550781 62.6875 C 58.246094 62.019531 59.257812 63.078125 58.5625 63.746094 L 47.300781 74.597656 C 48.285156 75.355469 49.199219 76.082031 50.003906 76.769531 C 57.449219 70.417969 73.710938 61.773438 73.542969 51.308594 C 73.34375 39.386719 58.914062 33.929688 51.023438 42.546875 Z M 51.023438 42.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,71.764706%,30.980392%)",
      fillOpacity: 1
    },
    d: "M 49.9375 32.375 C 52.835938 32.375 55.1875 30.023438 55.1875 27.125 C 55.1875 24.226562 52.835938 21.875 49.9375 21.875 C 47.039062 21.875 44.6875 24.226562 44.6875 27.125 C 44.6875 30.023438 47.039062 32.375 49.9375 32.375 Z M 49.9375 32.375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespectGray100);
export default __webpack_public_path__ + "static/media/respect-gray-100.93d92847.svg";
export { ForwardRef as ReactComponent };